/**
 * Recursively removes all targetKey keys from the input object.
 * @param {Object|Array} obj - The input object or array.
 * @param targetKeys
 * @returns {Object|Array} - A new object or array without targetKey keys.
 */
function removeKeys(obj, targetKeys) {
  if (Array.isArray(targetKeys)) {
    for (const targetKey of targetKeys) {
      obj = removeKeys(obj, targetKey)
    }
  } else {

    const targetKey = targetKeys

    if (Array.isArray(obj)) {
      return obj.map(item => removeKeys(item, targetKey))
    } else if (obj !== null && typeof obj === 'object') {
      const newObj = {}
      for (const key in obj) {
        if (obj.hasOwnProperty(key) && key !== targetKey) {
          newObj[key] = removeKeys(obj[key], targetKey)
        }
      }
      return newObj
    }
  }
  return obj
}

/**
 *
 * @param {Object} obj - The input object.
 * @returns {{}|*}
 */
function convertObject(obj) {
  if (Array.isArray(obj)) {
    return obj.map(convertObject)
  }

  if (typeof obj === 'object' && obj !== null) {
    const newObj = {}

    for (const key in obj) {
      if (key === 'active') {
        newObj[key] = obj[key] === '1'
      } else if (key === 'value' && obj.inputType === 'number') {
        newObj[key] = Number(obj[key])
      } else if (key === 'value' && obj.inputType === 'checkbox') {
        newObj[key] = obj[key] === '1'
      } else {
        newObj[key] = convertObject(obj[key])
      }
    }

    return newObj
  }

  return obj
}

/**
 *
 * @param {Object} obj
 * @returns {{}|*}
 */
export const purifyCustomizationObject = (obj) => {
  return convertObject(removeKeys(obj, ['_meta', 'rules', 'options']))
}
